"use client"

import { motion } from "framer-motion"
import { Button } from "@/components/ui/button"
import Link from "next/link"
import { Download } from "lucide-react"
import { usePriceLabels } from "@/lib/contexts/PricingCurrencyContext"

const MotionDiv = motion.div

export function MidPageCTA() {
  const prices = usePriceLabels()
  return (
    <section className="relative py-20">
      <div className="mx-auto max-w-3xl px-6 lg:px-8">
        <MotionDiv
          initial={false}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="relative overflow-hidden rounded-2xl bg-gray-50 dark:bg-white/5 border border-gray-200 dark:border-white/10 p-10 text-center shadow-lg"
        >
          <div className="relative z-10">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-3 tracking-tight">
              Ready to Ace Your Next Interview?
            </h2>
            <p className="text-gray-600 dark:text-gray-400 mb-8 max-w-xl mx-auto text-sm sm:text-base">
              Download now — invisible, undetectable, and works on every platform. Plans start at{" "}
              {prices.startingTagline}.
            </p>
            <div className="flex items-center justify-center">
              <Button
                asChild
                className="gap-2 text-sm font-semibold h-10 w-[240px] bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white border-0"
              >
                <Link href="/download" className="flex items-center gap-2">
                  <Download className="w-4 h-4" />
                  Start Free
                </Link>
              </Button>
            </div>
          </div>
        </MotionDiv>
      </div>
    </section>
  )
}
